import './style.scss'
import React from 'react'
import { rem } from 'src/componentv2/Base/ui'

interface IconProps {
    children: React.ReactNode
    size?: string
    color?: string
    className?: string
    onClick?: () => void
}

export const Icon: React.FC<IconProps> = ({
                                              children, size = '2', color, className = '', onClick,
                                          }) => (
    <span
        className={`icon ${className}`}
        onClick={onClick}
        style={{
            width: rem(size),
            height: rem(size),
            color,
            cursor: onClick ? 'pointer' : undefined,
        }}
    >
        {children}
    </span>
)

export default Icon